import React from 'react';
import { Navbar } from '../../components';
import { JournalHeader } from '../../containers';

const Journal = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <JournalHeader />
        </div>
    </div>
  )
}

export default Journal